import styled from 'styled-components';

const ConvertedPrice = styled.div`
  text-transform: capitalize;
  color: #999;
`;

export default ConvertedPrice;
